import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { CommonDataQuery } from '../selector/commonDataSelectors';
import CustomLoadable from '../util/CustomLoadable';
import BodyWrap from './BodyWrap';
import HeaderWrap from './HeaderWrap';
import globalState from 'state/globalState';
import AdminApi from 'api/AdminApi';
import { EnvType } from '@metadata';
import env from '../config/env';
import { useLocation } from 'react-router-dom';

function AppContainer() {
  const ENV: EnvType = env() as EnvType;
  const location = useLocation();

  const setCommonData = useSetRecoilState(CommonDataQuery);
  const load = useRecoilValueLoadable(CommonDataQuery);
  const [result, isLoading] = CustomLoadable(load);

  const [modalOpen, setModalOpen] = useState(false);

  const [userState, setUserState] = useRecoilState(globalState);

  const redirectToMainPage = () => {
    window.location.href = '/main';
  };

  const getUserData = async (userId: string) => {
    const result = await AdminApi.getUserData(userId);

    if (!result) {
      window.alert('잘못된 접근입니다. 메인페이지로 이동합니다.');
      redirectToMainPage();
    } else {
      const dt = result.userInfo;
      const services = result.userService;

      const transformedServices = services.reduce((acc, curr) => {
        acc[curr.service_id] = curr.stae;
        return acc;
      }, {});

      const roles = services.reduce((acc, curr) => {
        acc[curr.service_id] = curr.user_role;
        return acc;
      }, {});

      if (transformedServices['CROPS'] !== '승인') {
        window.alert('권한이 없는 사용자입니다. 메인페이지로 이동합니다.');
        redirectToMainPage();
      } else {
        setUserState((prevState) => ({
          ...prevState,
          UserInformation: {
            ...prevState.UserInformation,
            regUserId: dt.reg_user_id,
            userId: dt.user_id,
            user_nm: dt.user_nm,
            regUserName: dt.reg_user_id,
            // ofcNm: '',
            // CompanyID: '',
            // CompanyName: '',
            // ServiceID: '',
            ctpvNm: dt.ctpv_nm,
            deptNm: dt.dept_nm,
          },
          isLogin: true,
          isAdmin: roles.CROPS === 'MANAGER',
          stae: transformedServices,
          userService: roles,
        }));
      }
    }
  };



  useEffect(() => {
    if (result) {
      setCommonData((prev: any) => ({ ...prev, result }));
    }
  }, [result, setCommonData]);



  return (
    <div className="wrap">
      <HeaderWrap setModalOpen={setModalOpen} />
      {isLoading ? <CircularProgress /> : <BodyWrap />}

    </div>
  );
}

export default AppContainer;
